<template>
    <div>
        <div class="row">
            <div class="col-3">
                <label for="colorShadow"
                    >Цвет тени</label
                >
                <b-form-input
                    type="color"
                    id="colorShadow"
                    v-model="colorShadow"
                    @input="updateShadow"
                ></b-form-input>
            </div>
            <div class="col-9">
                <div class="row">
                    <div class="col-6">
                        <div>
                            <label for="valueShadowBlur"
                                >Размытие тени:
                                {{
                                    valueShadowBlur
                                }}</label
                            >
                            <b-form-input
                                id="valueShadowBlur"
                                v-model="
                                    valueShadowBlur
                                "
                                type="range"
                                min="0"
                                :max="maxValueBrush"
                                @input="updateShadow"
                            ></b-form-input>
                        </div>
                    </div>
                    <div class="col-6">
                        <div>
                            <label for="offsetShadowX"
                                >Отступ по оси X:
                                {{
                                    offsetShadow.x
                                }}</label
                            >
                            <b-form-input
                                id="offsetShadowX"
                                v-model="offsetShadow.x"
                                type="range"
                                :min="-maxValueBrush"
                                :max="maxValueBrush"
                                @input="updateShadow"
                            ></b-form-input>
                        </div>
                        <div>
                            <label for="offsetShadowY"
                                >Отступ по оси Y:
                                {{
                                    offsetShadow.y
                                }}</label
                            >
                            <b-form-input
                                id="offsetShadowY"
                                v-model="offsetShadow.y"
                                type="range"
                                :min="-maxValueBrush"
                                :max="maxValueBrush"
                                @input="updateShadow"
                            ></b-form-input>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="text-right">
            <b-button
                size="sm"
                pill
                variant="outline-primary"
                @click="resetShadow"
                >Сбросить</b-button
            >
        </div>
    </div>
</template>

<script>
import { fabric } from "fabric";

export default {
    props:[
        "canvas",
        "blur",
        "color",
        "offset"
    ],
    data(){
        return {
            maxValueBrush:100,
            valueShadowBlur:this.blur,
            colorShadow:this.color,
            offsetShadow:this.offset
        }
    },
    methods:{
        updateShadow() {
			this.canvas.getActiveObject().set({
				shadow: new fabric.Shadow({
					blur: parseInt(this.valueShadowBlur, 10) || 0,
					offsetX: this.offsetShadow.x,
					offsetY: this.offsetShadow.y,
					affectStroke: true,
					color: this.colorShadow,
				}),
			});
			this.canvas.requestRenderAll();
		},
        resetShadow() {
			this.valueShadowBlur = 0;
			this.offsetShadow.x = 0;
			this.offsetShadow.y = 0;
			this.updateShadow();
		},
    }
}
</script>

<style>

</style>